// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"b5a35705","28":"6fc0d6b0","247":"ff416048","292":"1dba2fb4","521":"5bc953d1","524":"865b35da","575":"1dba2fb4","583":"b8980de5","760":"d0597599","863":"b5a35705","911":"e7a5d8de"}[chunkId] + ".chunk.css";
};